import { SvgIcon, SvgIconProps } from '../../../icons/SvgIcon';

export const PersonCircleIcon = (props: SvgIconProps): JSX.Element => {
  return (
    <SvgIcon {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10 2.75C5.99594 2.75 2.75 5.99594 2.75 10C2.75 11.8565 3.44778 13.55 4.59537 14.8325C5.65821 13.0353 7.93585 12.25 10 12.25C12.0641 12.25 14.3418 13.0353 15.4046 14.8325C16.5522 13.55 17.25 11.8565 17.25 10C17.25 5.99594 14.0041 2.75 10 2.75ZM18.75 10C18.75 14.8325 14.8325 18.75 10 18.75C5.16751 18.75 1.25 14.8325 1.25 10C1.25 5.16751 5.16751 1.25 10 1.25C14.8325 1.25 18.75 5.16751 18.75 10ZM13.0003 16.4058C12.1078 16.9453 11.086 17.25 10 17.25C8.91404 17.25 7.89219 16.9453 6.99975 16.4058C6.60895 16.1695 6.24251 15.8879 5.90667 15.5667C6.61053 14.4289 8.20066 13.75 10 13.75C11.7993 13.75 13.3895 14.4289 14.0933 15.5667C13.7575 15.8879 13.3911 16.1695 13.0003 16.4058ZM8.25 8C8.25 7.0335 9.0335 6.25 10 6.25C10.9665 6.25 11.75 7.0335 11.75 8C11.75 8.9665 10.9665 9.75 10 9.75C9.0335 9.75 8.25 8.9665 8.25 8ZM10 4.75C8.20507 4.75 6.75 6.20507 6.75 8C6.75 9.79493 8.20507 11.25 10 11.25C11.7949 11.25 13.25 9.79493 13.25 8C13.25 6.20507 11.7949 4.75 10 4.75Z"
        fill="currentColor"
      />
    </SvgIcon>
  );
};
